(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-delivery-selector"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tw-delivery-selector')) {
customElements.define('tw-delivery-selector', class extends HTMLElement {
connectedCallback() {
if (this.ready) return; this.ready=true; this.form=this.querySelector('form'); this.status=this.querySelector('[data-status]'); this.t=JSON.parse(this.querySelector('[data-i18n]').textContent);
this.stores=JSON.parse(this.querySelector('[data-stores]').textContent).rows.map(r=>({brand:r[0],id:r[1],name:r[2],city:r[3],district:r[4],address:r[5]}));
this.form.addEventListener('change',e=>{if(e.target.name==='method')this.switchMethod();if(e.target.name==='storeCity')this.fillDistricts();if(e.target.name==='storeDistrict')this.fillStores();if(e.target.name==='storeId')this.showStore();if(e.target.name==='country')this.form.elements.namedItem('district').required=/^(TW|Taiwan|台灣|臺灣)$/.test(this.value('country'));});
this.form.addEventListener('submit',e=>{e.preventDefault();this.checkout();});
this.restore();
this.onPageShow=()=>{this.busy=false;this.form.querySelectorAll('input,select,button').forEach(c=>c.disabled=false);const home=this.value('method')==='home';this.querySelector('[data-home]').disabled=!home;this.querySelector('[data-store]').disabled=home;this.status.textContent='';};window.addEventListener('pageshow',this.onPageShow);
}
disconnectedCallback(){window.removeEventListener('pageshow',this.onPageShow);}
value(name){return this.form.elements.namedItem(name).value.trim();}
options(name,values,prompt){const select=this.form.elements.namedItem(name);select.replaceChildren(new Option(prompt,''));for(const value of values)select.add(new Option(value.label||value,value.value||value));}
switchMethod(){const home=this.value('method')==='home';for(const[selector,enabled]of [['[data-home]',home],['[data-store]',!home]]){const f=this.querySelector(selector);f.hidden=!enabled;f.disabled=!enabled;}this.status.textContent='';this.querySelector('[data-store-address]').textContent='';if(home)return;this.options('storeCity',[...new Set(this.stores.filter(s=>s.brand===this.value('method')).map(s=>s.city))].sort((a,b)=>a.localeCompare(b,'zh-Hant')),this.t.cityPrompt);this.options('storeDistrict',[],this.t.districtPrompt);this.options('storeId',[],this.t.storePrompt);}
fillDistricts(){this.options('storeDistrict',[...new Set(this.stores.filter(s=>s.brand===this.value('method')&&s.city===this.value('storeCity')).map(s=>s.district))].sort((a,b)=>a.localeCompare(b,'zh-Hant')),this.t.districtPrompt);this.options('storeId',[],this.t.storePrompt);this.showStore();}
fillStores(){this.options('storeId',this.stores.filter(s=>s.brand===this.value('method')&&s.city===this.value('storeCity')&&s.district===this.value('storeDistrict')).sort((a,b)=>a.name.localeCompare(b.name,'zh-Hant')).map(s=>({value:s.id,label:s.name+'（'+s.id+'）'})),this.t.storePrompt);this.showStore();}
selectedStore(){return this.stores.find(s=>s.brand===this.value('method')&&s.id===this.value('storeId')&&s.city===this.value('storeCity')&&s.district===this.value('storeDistrict'));}
showStore(){this.querySelector('[data-store-address]').textContent=this.selectedStore()?.address||'';}
restore(){const saved=JSON.parse(this.querySelector('[data-saved]').textContent);const a=saved||{};const fields={recipient:'收件人姓名',phone:'收件人手機',country:'收件國家',city:'收件縣市',district:'收件區域',address:'收件地址',zip:'收件郵遞區號'};const countrySelect=this.form.elements.namedItem('country');const taiwan=[...countrySelect.options].find(o=>/^(Taiwan|TW|台灣|臺灣)$/.test(o.value));if(taiwan)countrySelect.value=taiwan.value;for(const[k,v]of Object.entries(fields))if(a[v]&&(!a['取貨門市店號']||['recipient','phone'].includes(k)))this.form.elements.namedItem(k).value=a[v];if(!countrySelect.value&&taiwan)countrySelect.value=taiwan.value;const method={'宅配':'home','全家取貨':'family','7-11 取貨':'seven'}[a['配送方式']]||'home';this.form.elements.namedItem('method').value=method;this.switchMethod();if(method!=='home'){this.form.elements.namedItem('storeCity').value=a['收件縣市']||'';this.fillDistricts();this.form.elements.namedItem('storeDistrict').value=a['收件區域']||'';this.fillStores();this.form.elements.namedItem('storeId').value=a['取貨門市店號']||'';this.showStore();}}
async checkout(){
if(this.busy||!this.form.reportValidity())return;const method=this.value('method');const store=method==='home'?null:this.selectedStore();if(method!=='home'&&!store){this.status.textContent=this.t.invalidStore;return;}
const country=store||/^(TW|Taiwan|台灣|臺灣)$/.test(this.value('country'))?'TW':this.value('country');
const address=store?.address||[this.value('city'),this.value('district'),this.value('address')].join('');
const attributes={'配送方式':{home:'宅配',family:'全家取貨',seven:'7-11 取貨'}[method],'收件人姓名':this.value('recipient'),'收件人手機':this.value('phone'),'收件國家':country,'收件縣市':store?.city||this.value('city'),'收件區域':store?.district||this.value('district'),'收件地址':store?.address||this.value('address'),'收件郵遞區號':store?'':this.value('zip'),'取貨門市店號':store?.id||'','取貨門市名稱':store?.name||'','門市資料日期':store?this.dataset.date:''};
const params=new URLSearchParams();const shipping={first_name:'',last_name:this.value('recipient'),address1:address,address2:store?attributes['配送方式']+' '+store.name+' '+store.id:'',city:store?.city||this.value('city'),country,zip:store?'':this.value('zip'),phone:this.value('phone')};for(const[k,v]of Object.entries(shipping))params.set('checkout[shipping_address]['+k+']',v);
const contactPhone=this.value('phone').replace(/[\s()-]/g,'');
params.set('checkout[phone]',country==='TW'&&/^09\d{8}$/.test(contactPhone)?'+886'+contactPhone.slice(1):contactPhone);
this.busy=true;const controls=[...this.form.querySelectorAll('input,select,button')];const previous=controls.map(c=>c.disabled);controls.forEach(c=>c.disabled=true);this.status.textContent=this.t.saving;
try{const note=document.querySelector('textarea[name="note"]');const payload={attributes};if(note)payload.note=note.value;const r=await fetch(this.dataset.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:AbortSignal.timeout(15000)});if(!r.ok)throw new Error('save failed');const cart=await r.json();if(!cart.item_count||Object.entries(attributes).some(([k,v])=>(cart.attributes?.[k]||'')!==v))throw new Error('verification failed');window.location.assign(this.dataset.root+'checkout?'+params.toString());}
catch(_){this.status.textContent=this.t.saveError;this.busy=false;controls.forEach((c,i)=>c.disabled=previous[i]);}
}
});
}

  } catch(e) { console.error(e); }
})();
})();
